import Layout from '@/views/Layout/Index.vue'
import { RouteRecordRaw } from 'vue-router'

export default <RouteRecordRaw>{
  path: '/Customer',
  component: Layout,
  redirect: '/Home',
  name: 'Customer',
  meta: { title: '会员', icon: 'lock' },
  children: [
    {
      path: '/Customer/List',
      component: () => import(/* webpackChunkName: "NotifyAssistant" */ '@/views/Customer/List/Index.vue'),
      meta: { title: '会员管理', icon: 'el-icon-menu', roles: [] }
    },
    {
      path: '/Customer/Rank',
      component: () => import(/* webpackChunkName: "NotifyAssistant" */ '@/views/Customer/Rank/Index.vue'),
      meta: { title: '等级管理', icon: 'el-icon-user', roles: [] }
    },
    {
      path: '/Customer/Queue',
      component: () => import(/* webpackChunkName: "NotifyAssistant" */ '@/views/Customer/Queue/Index.vue'),
      meta: { title: '队列管理', icon: 'el-icon-user', roles: [] }
    }
  ]
}